import { ReportsComponentProps } from '../../../../components/reports/interfaces/reports-component-props';
import { useDataProvider } from '../../../../hooks/data-provider/data-provider.hook';
import { formatBigNumber } from '../../../../utils/formatting/number-formatter.helper';
import './sales-kpi.component.scss';

interface SalesKpiComponentProps extends ReportsComponentProps {
  title: string;
}
export const SalesKpiComponent = ({
  reportName: reportId,
  enabled,
  className,
  filterSelection,
  title,
}: SalesKpiComponentProps) => {
  const { data } = useDataProvider<Record<string, any>>(
    reportId,
    filterSelection,
    undefined,
    enabled,
  );

  return (
    <div className={className}>
      {data?.rows.map((row, index) => (
        <div key={index} className="">
          <span className="sales-kpi-title sales-kpi-text">{title}</span>
          {data?.measureColumns.map((col) => (
            <span
              key={`${col.id}-${row[col.id]?.toString()}`}
              className="sales-kpi-value sales-kpi-text text-end"
            >
              {formatBigNumber(row[col.id])}
            </span>
          ))}
        </div>
      ))}
    </div>
  );
};
